import React from 'react'

interface ButtonProps {
    children: React.ReactNode
    onClick?: (e?: React.MouseEvent) => void
    type?: 'button' | 'submit' | 'reset'
    disabled?: boolean
    loading?: boolean
    className?: string
    variant?: 'btn_add' | 'btn_secondary' | 'btn_danger' | 'btn_success'
    size?: 'sm' | 'md' | 'lg'
}

const Button: React.FC<ButtonProps> = ({
    children,
    onClick,
    type = 'button',
    disabled = false,
    loading = false,
    className = '',
    variant = 'btn_add',
    size = 'md'
}) => {
    const getVariantClasses = () => {
        switch (variant) {
            case 'btn_add':
                return 'bg-[rgb(235,106,59)] hover:bg-[rgb(220,95,50)] text-white font-medium transition-colors duration-200'
            case 'btn_secondary':
                return 'bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium transition-colors duration-200 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-300'
            case 'btn_danger':
                return 'bg-red-600 hover:bg-red-700 text-white font-medium transition-colors duration-200'
            case 'btn_success':
                return 'bg-green-600 hover:bg-green-700 text-white font-medium transition-colors duration-200'
            default:
                return 'bg-[rgb(235,106,59)] hover:bg-[rgb(220,95,50)] text-white font-medium transition-colors duration-200'
        }
    }

    const getSizeClasses = () => {
        switch (size) {
            case 'sm':
                return 'px-3 py-1.5 text-sm rounded-md'
            case 'md':
                return 'px-4 py-2 text-sm rounded-lg'
            case 'lg':
                return 'px-6 py-3 text-base rounded-lg'
            default:
                return 'px-4 py-2 text-sm rounded-lg'
        }
    }

    const baseClasses = 'inline-flex items-center justify-center border-0 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[rgb(235,106,59)] disabled:opacity-50 disabled:cursor-not-allowed'

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={`${baseClasses} ${getVariantClasses()} ${getSizeClasses()} ${className}`}
        >
            {loading && (
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            )}
            {children}
        </button>
    )
}

export default Button
